import type React from 'react';

import type * as api from '@gitbook/api-client';
import { Icon } from '@gitbook/spine-icons';
import {
    Button,
    Description,
    DialogRoot,
    DialogTrigger,
    EmptyState,
    EmptyStateActions,
    EmptyStateIcon,
    Heading,
} from '@gitbook/spine-react';

import { bgGradient } from '../../assets';
import { CreateSiteDialog } from '../../Components';

/**
 * Blankslate when no sites have been created yet.
 */
export function SitesListBlankslate(props: { organization: api.Organization }): React.ReactElement {
    const { organization } = props;

    return (
        <div className="relative flex flex-1 flex-col items-center justify-center overflow-hidden p-7">
            <div
                className="absolute inset-0"
                style={{
                    background: `center / cover no-repeat url(${bgGradient.light})`,
                }}
            />

            <div className="w-full">
                <EmptyState className="relative w-full max-w-128 bg-base shadow-elevated">
                    <EmptyStateIcon>
                        <Icon.DocsSite />
                    </EmptyStateIcon>
                    <Heading>Create your first site</Heading>
                    {organization.permissions.createContent ? (
                        <>
                            <Description>
                                Create and publish your first documentation site.
                            </Description>
                            <EmptyStateActions>
                                <DialogRoot>
                                    <DialogTrigger>
                                        <Button
                                            kind="secondary"
                                            label="Create a new site"
                                            leadingIcon={Icon.Plus}
                                        />
                                    </DialogTrigger>

                                    <CreateSiteDialog organizationId={organization.id} />
                                </DialogRoot>
                            </EmptyStateActions>
                        </>
                    ) : (
                        <Description>
                            You don't seem to have permission to create a site. Reach out to your
                            organization's admin to get started.
                        </Description>
                    )}
                </EmptyState>
            </div>
        </div>
    );
}
